(function () {
  if (window.__subscriptionIncentivesDrawerInitialised) {
    return;
  }

  window.__subscriptionIncentivesDrawerInitialised = true;

  var drawer = document.getElementById('subscription-incentives-drawer');

  document.addEventListener('click', function (event) {
    var clickTarget = event.target;

    if (!clickTarget || typeof clickTarget.closest !== 'function') {
      return;
    }

    var trigger = clickTarget.closest(
      'a.loop-incentives-trigger[href="#subscription-incentives-drawer"], a[href="#subscription-incentives-drawer"]'
    );

    if (!trigger) {
      return;
    }

    if (!drawer || typeof drawer.show !== 'function') {
      return;
    }

    event.preventDefault();
    drawer.show();
  });
})();
